import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import arrive from "../../../asset/arrive.png";
import depart from "../../../asset/depart.png";
import transparent from "../../../asset/transparent.png";

import "leaflet-routing-machine";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: null,
  iconUrl: transparent,
  shadowUrl: null,
});

const RoutingMachine = ({ startLat, startLng, endLat, endLng }) => {
  const map = useMap();

  useEffect(() => {
    const routingControl = L.Routing.control({
      waypoints: [
        L.latLng(startLat, startLng),
        L.latLng(endLat, endLng),
      ],
      routeWhileDragging: false,
      show: false,
      addWaypoints: false,
      draggableWaypoints: false,
      waypointMode: "none",
      createMarker: () => null,
      lineOptions: {
        styles: [{ color: "#6366f1", weight: 4, opacity: 0.85 }],
        addWaypoints: false,
      },
      router: new L.Routing.OSRMv1({
        serviceUrl: "https://router.project-osrm.org/route/v1",
      }),
    }).addTo(map);

    routingControl.on("routesfound", (e) => {
      const route = e.routes[0];
      const bounds = L.latLngBounds(route.coordinates);
      map.fitBounds(bounds, { padding: [30, 30], maxZoom: 14 });

      setTimeout(() => {
        const paths = map
          .getContainer()
          .querySelectorAll(".leaflet-overlay-pane path");
        paths.forEach((path) => {
          const length = path.getTotalLength();
          path.style.strokeDasharray = length;
          path.style.strokeDashoffset = length;
          path.style.transition = "none";
          path.getBoundingClientRect();
          path.style.transition = "stroke-dashoffset 2s ease-in-out";
          path.style.strokeDashoffset = "0";
        });
      }, 300);
    });

    return () => {
      try {
        if (routingControl.getPlan()) {
          routingControl.getPlan().setWaypoints([]);
        }
        map.removeControl(routingControl);
      } catch (e) {
        // Ignore cleanup errors when map is already unmounted
      }
    };
  }, [map, startLat, startLng, endLat, endLng]);

  return null;
};

const MiniMap = ({
  startLatitude,
  startLongitude,
  endLatitude,
  endLongitude,
}) => {
  const startCoordinates = [startLatitude, startLongitude];
  const endCoordinates = [endLatitude, endLongitude];

  const customDepartIcon = L.icon({
    iconUrl: depart,
    shadowUrl: null,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
  });

  const customArriveIcon = L.icon({
    iconUrl: arrive,
    shadowUrl: null,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
  });

  return (
    <div className="h-[200px] sm:h-[250px] w-full">
    <MapContainer
      center={startCoordinates}
      zoom={8}
      style={{ width: "100%", height: "100%" }}
      className="z-0"
    >
      <TileLayer
        attribution='  &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        minZoom={0}
        maxZoom={19}
      />
      <Marker icon={customDepartIcon} position={startCoordinates}>
        <Popup>Départ</Popup>
      </Marker>
      <Marker icon={customArriveIcon} position={endCoordinates}>
        <Popup>Arrivée</Popup>
      </Marker>
      <RoutingMachine
        startLat={startLatitude}
        startLng={startLongitude}
        endLat={endLatitude}
        endLng={endLongitude}
      />
    </MapContainer>
    </div>
  );
};

export default MiniMap;
